"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ImageType;
(function (ImageType) {
    ImageType["MAIN"] = "main";
    ImageType["FRONT"] = "front";
    ImageType["REAR"] = "rear";
    ImageType["INTERIOR"] = "interior";
    ImageType["FRONT360"] = "exterior360_31";
    ImageType["IMAGE"] = "image";
    ImageType["PROFILE"] = "profile";
})(ImageType = exports.ImageType || (exports.ImageType = {}));
